import React from 'react';
import { DashboardRouter } from 'router/router';
import { Loading } from 'ui-components/loading/loading-component';
import { GeneralAndInitializersMemo } from 'features/general-and-initializers/general-and-initializers';
import { Header } from 'features/header/header';
import { DesktopPiDrawerContainer } from 'features/pi/view/drawer/desktop-pi-drawer-container';
import { getFeatureFlags } from 'core/flow-control';

export interface DesktopAppProps {
    isReady: boolean;
}

export const DesktopApp = (_: DesktopAppProps) => {
    const { enable_pi_feedback_ff } = getFeatureFlags();

    return (
        <DesktopPiDrawerContainer supportFeedback={!!enable_pi_feedback_ff}>
            <DashboardRouter
                AppLoader={<Loading className="pl-app-loader" show />}
                RouteLoader={<Loading className="pl-route-loader" show />}
                Initializers={<GeneralAndInitializersMemo />}
                Header={<Header />}
            />
        </DesktopPiDrawerContainer>
    );
};

export const DesktopAppMemo = React.memo(
    DesktopApp,
    (previousProps: DesktopAppProps, nextProps: DesktopAppProps) => {
        return previousProps.isReady === nextProps.isReady;
    },
);
DesktopAppMemo.displayName = 'DesktopApp - memo';
